namespace GeniuzPOS.ReportMasterData {
    export class Report_1405Columns {
        static columnsKey = 'ReportMasterData.Report_1405';
    }
}
